const generateForm = (formData) => {
    const form = document.createElement('form');
    for (const key in formData) {
        if (formData.hasOwnProperty(key)) {
            const inputElement = document.createElement('input');
            inputElement.name = key;
            inputElement.value = formData[key];
            inputElement.type = 'hidden';
            form.appendChild(inputElement);
        }
    }
    return form;
}

export default generateForm